export default __webpack_public_path__ + "static/media/icon-clock.c4956a8f.svg";